import { getDefaultStore, useAtomValue } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export interface SitePreviewData {
  isViewLoading: boolean;
}

const defaultSitePreviewData: SitePreviewData = {
  isViewLoading: false,
};

export const SitePreviewDataAtom = atomWithReset<SitePreviewData>(defaultSitePreviewData);

export const useSitePreviewData = () => {
  return useAtomValue(SitePreviewDataAtom);
};

export const setSitePreviewData = (partialData: Partial<SitePreviewData>) => {
  const store = getDefaultStore();
  store.set(SitePreviewDataAtom, (prev) => ({
    ...prev,
    ...partialData,
  }));
};

export const resetSitePreviewData = () => {
  const store = getDefaultStore();
  store.set(SitePreviewDataAtom, defaultSitePreviewData);
};
